import React from "react";
import EmptyState from "components/EmptyState";
import { useParams } from "react-router";
import { buildingStore } from "store/Building/BuildingStore";
import Retool from ".";

const CircularityDashboard = () => {
  const reportID = "1418864e-9393-11ef-bcac-7b0c5388f917";
  const { id: BuildingId } = useParams();

  const embeddedData = {
    building_id: BuildingId,
  };

  if (!buildingStore.buildingMappingStatus.hasReport)
    return (
      <EmptyState
        type="inventory"
        loading={buildingStore.calculationsStatus.inProgress}
        containerClassName="m-6"
      />
    );

  return (
    <Retool
      url={reportID}
      embeddedData={embeddedData}
      className="h-[calc(100vh-120px)]"
    />
  );
};

export default CircularityDashboard;
